const productEntity = {
  id: "",
  external_reference_key: "",
  name: "",
  products: [],
};
export default productEntity;
